import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';
import { BuilderSections } from '../../util/builder';
import { getGenderFilterConfig } from '../filters/gender';

const pactSizes = [
  'XX-Small',
  'Extra Small',
  'Small',
  'Medium',
  'Large',
  'X-Large',
  '2X-Large',
  '3X-Large',
  'One Size',
];

export const pactShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({ sizes: pactSizes }),
    getGenderFilterConfig(),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageContent]: '38630ab1383948449bdfcae059254593',
    },
  },
  additionalPayoutSettings: {
    creditCodeHelperText: 'Keep in mind that all Pact Cash expires 90 days after it’s earned.',
  },
};
